import { ShopNotification } from 'actions/actionTypes';

export const resetAllHub = () => ({ type: ShopNotification.RESET_ALL_HUB });

export const changeShopNotificationHub = (hub) => ({ type: ShopNotification.CHANGE_SHOP_NOTIFICATION_HUB, payload: hub });

export const changeShopNotification = (message) => ({ type: ShopNotification.CHANGE_SHOP_NOTIFICATION, payload: message });
export const showShopNotification = (isShow) => ({ type: ShopNotification.SHOW_SHOP_NOTIFICATION, payload: isShow });

export const loadShopNotificationInfoRequest = (notificationId) => ({ type: ShopNotification.LOAD_SHOP_NOTIFICATION_INFO_REQUEST, payload: notificationId });
export const loadShopNotificationInfoRequestSuccess = (responseData) => ({ type: ShopNotification.LOAD_SHOP_NOTIFICATION_INFO_REQUEST_SUCCESS, payload: responseData });
export const loadShopNotificationInfoRequestFailure = (errorMessage) => ({ type: ShopNotification.LOAD_SHOP_NOTIFICATION_INFO_REQUEST_FAILURE, payload: errorMessage });